var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    "data-testid": "custom-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6709 10.7738V17.6298H1.95886V3.91773H6.87561C6.92458 3.22233 7.09109 2.56611 7.34574 1.95886H1.95886C0.881489 1.95886 0 2.84035 0 3.91773V17.6298C0 18.7071 0.881489 19.5886 1.95886 19.5886H15.6709C16.7483 19.5886 17.6298 18.7071 17.6298 17.6298V12.7326L15.6709 10.7738ZM14.2018 15.6709H3.42801L6.12145 12.2135L8.04114 14.525L10.7346 11.0578L14.2018 15.6709ZM16.9442 6.74829C17.3751 6.06268 17.6298 5.26934 17.6298 4.40744C17.6298 1.96866 15.6611 0 13.2223 0C10.7835 0 8.81489 1.96866 8.81489 4.40744C8.81489 6.84623 10.7835 8.81489 13.2125 8.81489C14.0744 8.81489 14.8776 8.56024 15.5534 8.12929L18.6092 11.1851L20 9.79432L16.9442 6.74829ZM13.2223 6.85602C11.8707 6.85602 10.7738 5.75906 10.7738 4.40744C10.7738 3.05583 11.8707 1.95886 13.2223 1.95886C14.5739 1.95886 15.6709 3.05583 15.6709 4.40744C15.6709 5.75906 14.5739 6.85602 13.2223 6.85602Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavReports);
export default __webpack_public_path__ + "static/media/nav-reports.90a44473.svg";
export { ForwardRef as ReactComponent };